import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60,
            retry: 3,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    },
});
